<!-- <header class="header is-hidden-mobile" > -->
<header class="header" >
  <div class="container-logo">
    <a (click)="goToHome()" >
      <img [src]="urlLogo" alt="" class="logo">
    </a>
  </div>
  <div class="container-menu">
    <!-- <span [routerLink]="['/restaurantes']"      routerLinkActive="selected" class="option-menu is-hidden-mobile">
      DOMICILIOS
    </span> -->
    <!-- <span [ngClass]="{'selected': itemMenuSelected == 2}" class="option-menu is-hidden-mobile">
      DOMICILIOS
    </span> -->
    <!-- <span [routerLink]="['/reservas']"          routerLinkActive="selected"  class="option-menu is-hidden-mobile">
      RESERVAS
    </span> -->
    <!-- <span *ngIf="hasSession" class="option-menu">
      <div class="container-icon" [ngClass]="{'notification': numberOrders > 0}" >
        <img (click)="openListOrders()" src="/assets/icons/alarm.svg" alt="" class="icon-alarm" >
        <span class="notification-icon"> {{ numberOrders }} </span>
      </div>
    </span> -->
    <!-- <span *ngIf="hasSession" class="option-menu is-hidden-mobile"> -->
    <span *ngIf="hasSession" class="option-menu ">
      <div class="container-icon" [ngClass]="{'notification': numberShoppingCar > 0}" >
        <img (click)="openShoppingCar()" src="/assets/icons/shoping-car.svg" alt="" class="icon-shopping" [ngClass]="{'show-car': showShoppingCar}" >
        <span class="notification-icon"> {{ numberShoppingCar }} </span>
      </div>
      <app-shopping-car ></app-shopping-car>
    </span>
    <!-- <span *ngIf="!hasSession" (click)="open()" class="option-menu is-hidden-mobile">
      INICIAR SESIÓN
    </span> -->
    <span *ngIf="hasSession" class="option-menu" (click)="openMenuDesktop()" >
      <span class="name-user">{{ user.name }}</span>
      <img src="/assets/icons/arrow-white.svg" alt="" class="icon-name-profile" >
      <app-menu-desktop *ngIf="menuDesktop" ></app-menu-desktop>
    </span>
    <!-- <span class="option-menu is-hidden-tablet">
      <a (click)="openMenuMobile()" routerLinkActive="selected"  > <img src="/assets/icons/menu.svg" alt="" class="icon-shopping" > </a>
    </span> -->
  </div>
</header>

  <div class="box-sized">
    
  </div>

<app-menu-mobile></app-menu-mobile>

<app-order-list></app-order-list>

<app-edit-shopping-car></app-edit-shopping-car>
